'use client';

import type {ComponentProps, FC, ReactNode} from 'react';

import classes from './Typography.module.css';

interface IProps {
  title?: string;
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'subtitle' | 'body1' | 'body2' | 'body3' | 'body4';
  className?: ComponentProps<'div'>['className'];
  style?: ComponentProps<'div'>['style'];
  children?: ReactNode;
}

const Typography: FC<IProps> = ({title, variant, children, className, style}) => {
  return (
    <>
      {variant === 'h1' && (
        <h1 className={`${classes.heading_h1} ${className}`} style={style}>
          {title}
          {children}
        </h1>
      )}
      {variant === 'h2' && (
        <h2 className={`${classes.heading_h2} ${className}`} style={style}>
          {title}
          {children}
        </h2>
      )}
      {variant === 'h3' && (
        <h3 className={`${classes.heading_h3} ${className}`} style={style}>
          {title}
          {children}
        </h3>
      )}
      {variant === 'h4' && (
        <h4 className={`${classes.heading_h4} ${className}`} style={style}>
          {title}
          {children}
        </h4>
      )}
      {variant === 'subtitle' && (
        <div className={`${classes.heading_subtitle} ${className}`} style={style}>
          {title}
          {children}
        </div>
      )}
      {variant === 'body1' && (
        <div className={`${classes.heading_body1} ${className}`} style={style}>
          {children}
        </div>
      )}
      {variant === 'body2' && (
        <div className={`${classes.heading_body2} ${className}`} style={style}>
          {title}
          {children}
        </div>
      )}
      {variant === 'body3' && (
        <div className={`${classes.heading_body3} ${className}`} style={style}>
          {title}
          {children}
        </div>
      )}
      {variant === 'body4' && (
        <div className={`${classes.heading_body4} ${className}`} style={style}>
          {title}
          {children}
        </div>
      )}
    </>
  );
};

export default Typography;
